import { NgModule } from '@angular/core';
import { PreloadAllModules, Route, RouterModule } from '@angular/router';
import { AuthGuard } from '@tcc-mono/shared/authentication/passport';


const routes: Route[] = [
  {
    path: 'app',
    loadChildren: () => import('@tcc-mono/classifact/mobile/home/feature').then(m => m.HomeModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('@tcc-mono/shared/authentication/passport').then(m => m.AuthenticationModule)
  },
  {
    path: '',
    redirectTo: 'app',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'app'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class ClassifactMobileRoutingModule { }
